<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <label class="form-label">Buscar email</label>
                <input
                  v-model="filters.email"
                  @input="onFilterChange"
                  type="text"
                  class="form-control"
                  placeholder="parcial@exemplo.com"
                />
              </div>
              <div class="col-md-3">
                <label class="form-label">Motivo</label>
                <select v-model="filters.reason" @change="onFilterChange" class="form-control">
                  <option value="">Todos</option>
                  <option value="bounce">Bounce</option>
                  <option value="complaint">Complaint (spam)</option>
                  <option value="unsubscribe">Unsubscribe</option>
                  <option value="manual">Manual</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Provider</label>
                <select v-model="filters.provider" @change="onFilterChange" class="form-control">
                  <option value="">Todos</option>
                  <option value="mailgun">Mailgun</option>
                  <option value="resend">Resend</option>
                  <option value="manual">Manual</option>
                </select>
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button type="button" class="btn btn-light btn-block" @click="clearFilters">
                  Limpar
                </button>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="text-right">
                  <button type="button" class="btn btn-info btn-rounded mb-2 mr-2" @click="openCheck">
                    <i class="mdi mdi-magnify mr-1"></i> Verificar lista
                  </button>
                  <button type="button" class="btn btn-success btn-rounded mb-2" @click="openAdd">
                    <i class="mdi mdi-plus mr-1"></i> Adicionar manual
                  </button>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="list.length > 0">
              <table class="table table-centered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th>Email</th>
                    <th style="width: 130px;">Motivo</th>
                    <th style="width: 110px;">Provider</th>
                    <th style="width: 180px;">Suprimido em</th>
                    <th style="width: 80px;">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in list" :key="item.id">
                    <td>
                      <h5 class="font-size-14 mb-0">{{ item.email }}</h5>
                      <small v-if="item.provider_event_id" class="text-muted">
                        id: {{ item.provider_event_id }}
                      </small>
                    </td>
                    <td>
                      <span class="badge font-size-12" :class="reasonBadgeClass(item.reason)">
                        {{ reasonLabel(item.reason) }}
                      </span>
                    </td>
                    <td>
                      <span class="badge badge-soft-secondary font-size-12">
                        {{ item.provider || '—' }}
                      </span>
                    </td>
                    <td>
                      <span class="text-muted">{{ formatDate(item.suppressed_at || item.created_at) }}</span>
                    </td>
                    <td>
                      <a href="#" @click.prevent="confirmDelete(item.id)" title="Remover supressão">
                        <i class="mdi mdi-trash-can font-size-18 text-danger"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="text-center py-5">
              <i class="mdi mdi-email-off-outline" style="font-size: 48px; color: #ced4da;"></i>
              <p class="text-muted mt-2">Nenhuma supressão encontrada</p>
            </div>

            <div v-if="meta.last_page > 1" class="row mt-3">
              <div class="col-12">
                <b-pagination
                  v-model="filters.page"
                  :total-rows="meta.total"
                  :per-page="meta.per_page"
                  @change="onPageChange"
                  align="right"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="addModal.show"
      title="Adicionar supressão manual"
      hide-footer
      @hidden="resetAdd"
    >
      <div class="form-group">
        <label>Email <span class="text-danger">*</span></label>
        <input
          type="email"
          v-model.trim="addModal.form.email"
          class="form-control"
          :class="{ 'is-invalid': addModal.submitted && !isValidEmail(addModal.form.email) }"
          placeholder="usuario@exemplo.com"
        />
        <div class="invalid-feedback">Email inválido.</div>
      </div>
      <div class="form-group">
        <label>Motivo <span class="text-danger">*</span></label>
        <select v-model="addModal.form.reason" class="form-control">
          <option value="unsubscribe">Unsubscribe (descadastro)</option>
          <option value="bounce">Bounce</option>
          <option value="complaint">Complaint (spam)</option>
        </select>
      </div>
      <div class="text-right">
        <button type="button" class="btn btn-light mr-2" @click="addModal.show = false">Cancelar</button>
        <button type="button" class="btn btn-success" :disabled="addModal.saving" @click="submitAdd">
          <span v-if="addModal.saving">Salvando…</span>
          <span v-else>Salvar</span>
        </button>
      </div>
    </b-modal>

    <b-modal
      v-model="checkModal.show"
      title="Verificar emails contra a lista de supressão"
      size="lg"
      hide-footer
      @hidden="resetCheck"
    >
      <p class="text-muted">
        Cole um email por linha. Útil antes de importar contatos para uma campanha.
      </p>
      <div class="form-group">
        <textarea
          v-model="checkModal.input"
          class="form-control"
          rows="8"
          placeholder="email1@dominio.com&#10;email2@dominio.com"
        ></textarea>
      </div>
      <div class="text-right mb-3">
        <button type="button" class="btn btn-light mr-2" @click="checkModal.show = false">Fechar</button>
        <button type="button" class="btn btn-info" :disabled="checkModal.loading || !parsedEmails.length" @click="submitCheck">
          <span v-if="checkModal.loading">Verificando…</span>
          <span v-else>Verificar {{ parsedEmails.length }} email(s)</span>
        </button>
      </div>
      <div v-if="checkModal.result !== null">
        <hr>
        <div class="row">
          <div class="col-md-6">
            <h5 class="text-danger">
              <i class="mdi mdi-alert-circle mr-1"></i>
              Suprimidos ({{ checkModal.result.length }})
            </h5>
            <ul class="list-unstyled" v-if="checkModal.result.length">
              <li v-for="email in checkModal.result" :key="'s-' + email">
                <span class="badge badge-soft-danger">{{ email }}</span>
              </li>
            </ul>
            <p v-else class="text-muted">Nenhum email suprimido.</p>
          </div>
          <div class="col-md-6">
            <h5 class="text-success">
              <i class="mdi mdi-check-circle mr-1"></i>
              Limpos ({{ cleanEmails.length }})
            </h5>
            <ul class="list-unstyled" v-if="cleanEmails.length">
              <li v-for="email in cleanEmails" :key="'c-' + email">
                <span class="badge badge-soft-success">{{ email }}</span>
              </li>
            </ul>
            <p v-else class="text-muted">Nenhum email limpo.</p>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import Swal from 'sweetalert2'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const REASON_LABELS = {
  bounce: 'Bounce',
  complaint: 'Complaint',
  unsubscribe: 'Unsubscribe',
  manual: 'Manual'
}
const REASON_CLASSES = {
  bounce: 'badge-soft-danger',
  complaint: 'badge-soft-warning',
  unsubscribe: 'badge-soft-secondary',
  manual: 'badge-soft-info'
}

export default {
  components: { Layout, PageHeader },
  data () {
    return {
      title: 'Supressões de Email',
      items: [{ text: 'Configurações', href: '/' }, { text: 'Supressões', active: true }],
      list: [],
      meta: {},
      filters: {
        email: '',
        reason: '',
        provider: '',
        page: 1,
        limit: 50
      },
      searchDebounce: null,
      addModal: {
        show: false,
        saving: false,
        submitted: false,
        form: { email: '', reason: 'unsubscribe' }
      },
      checkModal: {
        show: false,
        loading: false,
        input: '',
        result: null
      }
    }
  },
  computed: {
    ...mapState('emailSuppressions', { data: 'suppressions' }),
    parsedEmails () {
      return (this.checkModal.input || '')
        .split(/[\s,;]+/)
        .map(e => e.trim().toLowerCase())
        .filter(e => EMAIL_REGEX.test(e))
    },
    cleanEmails () {
      if (!this.checkModal.result) return []
      const suppressed = new Set(this.checkModal.result)
      return this.parsedEmails.filter(e => !suppressed.has(e))
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    ...mapActions('emailSuppressions', {
      fetch: 'GetSuppressions',
      save: 'SaveSuppression',
      remove: 'DeleteSuppression',
      check: 'CheckSuppressions'
    }),
    async loadList () {
      const loader = this.$loading.show()
      try {
        const params = { page: this.filters.page, limit: this.filters.limit }
        if (this.filters.email) params.email = this.filters.email
        if (this.filters.reason) params.reason = this.filters.reason
        if (this.filters.provider) params.provider = this.filters.provider

        await this.fetch(params)
        this.list = this.data.data || []
        this.meta = {
          total: this.data.total,
          per_page: this.data.per_page,
          current_page: this.data.current_page,
          last_page: this.data.last_page
        }
      } catch (error) {
        errorMessage('Falha ao carregar supressões.')
      } finally {
        loader.hide()
      }
    },
    onFilterChange () {
      clearTimeout(this.searchDebounce)
      this.searchDebounce = setTimeout(() => {
        this.filters.page = 1
        this.loadList()
      }, 350)
    },
    onPageChange (page) {
      this.filters.page = page
      this.$nextTick(() => this.loadList())
    },
    clearFilters () {
      this.filters.email = ''
      this.filters.reason = ''
      this.filters.provider = ''
      this.filters.page = 1
      this.loadList()
    },
    reasonLabel (r) { return REASON_LABELS[r] || r },
    reasonBadgeClass (r) { return REASON_CLASSES[r] || 'badge-soft-secondary' },
    formatDate (value) {
      if (!value) return '—'
      const d = new Date(value)
      if (isNaN(d.getTime())) return value
      return d.toLocaleString('pt-BR')
    },
    isValidEmail (v) { return EMAIL_REGEX.test(v || '') },
    openAdd () {
      this.resetAdd()
      this.addModal.show = true
    },
    resetAdd () {
      this.addModal.saving = false
      this.addModal.submitted = false
      this.addModal.form = { email: '', reason: 'unsubscribe' }
    },
    async submitAdd () {
      this.addModal.submitted = true
      if (!this.isValidEmail(this.addModal.form.email)) return
      this.addModal.saving = true
      try {
        await this.save({
          email: this.addModal.form.email.toLowerCase(),
          reason: this.addModal.form.reason,
          provider: 'manual'
        })
        successMessage('Supressão adicionada.')
        this.addModal.show = false
        this.loadList()
      } catch (error) {
        errorMessage(this.extractError(error) || 'Falha ao adicionar supressão.')
      } finally {
        this.addModal.saving = false
      }
    },
    openCheck () {
      this.resetCheck()
      this.checkModal.show = true
    },
    resetCheck () {
      this.checkModal.input = ''
      this.checkModal.result = null
      this.checkModal.loading = false
    },
    async submitCheck () {
      if (!this.parsedEmails.length) return
      this.checkModal.loading = true
      try {
        const res = await this.check(this.parsedEmails)
        this.checkModal.result = (res && res.suppressed) ? res.suppressed : []
      } catch (error) {
        errorMessage('Falha ao verificar lista.')
      } finally {
        this.checkModal.loading = false
      }
    },
    confirmDelete (id) {
      Swal.fire({
        title: 'Remover supressão?',
        text: 'O endereço voltará a receber emails. Use apenas se tiver certeza de que o bounce foi indevido.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.remove(id)
            successMessage('Supressão removida.')
            this.loadList()
          } catch (error) {
            errorMessage('Erro ao remover.')
          }
        }
      })
    },
    extractError (err) {
      return err && err.response && err.response.data && err.response.data.message
    }
  }
}
</script>
